// load these polyfills before any pvd components
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';
import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';
import "@fmr-ap109253/apex-kit/dist/umd/pvd.min.js";

import {
    PvdButton,
    PvdCheckbox,
    PvdCheckboxGroup,
    PvdContentBlock,
    PvdExpandCollapse,
    PvdFieldGroup,
    PvdFieldKey,
    PvdFootnote,
    PvdFootnotes,
    PvdForm,
    PvdFormActions,
    PvdIcon,
    PvdInlineAlert,
    PvdInput,
    PvdLabel,
    PvdLink,
    PvdMicrocopy,
    PvdModal,
    PvdPopover,
    PvdSelect,
    PvdTitle,
    injectSpriteSheet,
} from '@fmr-ap109253/apex-kit';

import App from './App.vue';
import Vue from 'vue';

injectSpriteSheet();
PvdButton.defineCustomElement()
PvdIcon.defineCustomElement();
PvdContentBlock.defineCustomElement();
PvdTitle.defineCustomElement();
PvdLink.defineCustomElement();
PvdPopover.defineCustomElement();
PvdFieldGroup.defineCustomElement();
PvdLabel.defineCustomElement();
PvdSelect.defineCustomElement();
PvdInput.defineCustomElement();
PvdMicrocopy.defineCustomElement();
PvdForm.defineCustomElement();
PvdFieldKey.defineCustomElement();
PvdFootnotes.defineCustomElement();
PvdFootnote.defineCustomElement();
PvdInlineAlert.defineCustomElement();
PvdFormActions.defineCustomElement();
PvdExpandCollapse.defineCustomElement();
PvdCheckbox.defineCustomElement();
PvdCheckboxGroup.defineCustomElement();
PvdModal.defineCustomElement();

Vue.config.productionTip = false;

new Vue({
    render: (h) => h(App),
}).$mount('#app');
